import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useTheme } from "@mui/material/styles";
import { useMemo } from "react";
import { CustomProvider } from "rsuite";
import enGB from "rsuite/locales/en_GB";
import ruRU from "rsuite/locales/ru_RU";
import { notReachable } from "../../shared/helpers";
import { DateRangePickerStyled, TimeRangePickerStyled, DatePickerStyled } from "./ui";
import { Typography, Stack, Icon } from "..";
import "rsuite/DateRangePicker/styles/index.css";
import "./styles/dataPicker.css";
import { CalendarIcon } from "@dion-web/ui-icons";
const DatePickerV2 = ({
  locale = "ru",
  className,
  header = "",
  type = "single-date",
  isTextField = true,
  ...props
}) => {
  const theme = useTheme();
  const renderDatePicker = useMemo(
    () => {
      switch (type) {
        case "single-date":
          return /* @__PURE__ */ jsxs(Stack, { className, children: [
            header && /* @__PURE__ */ jsx(Typography, { variant: "body2", marginBottom: 1, children: header }),
            /* @__PURE__ */ jsx(
              DatePickerStyled,
              {
                placeholder: "__.__.____",
                format: "dd.MM.yyyy",
                weekStart: 1,
                showHeader: false,
                caretAs: () => /* @__PURE__ */ jsx(Icon, { size: "l", icon: /* @__PURE__ */ jsx(CalendarIcon, {}) }),
                oneTap: true,
                ...props
              }
            )
          ] });
        case "week-date":
          return /* @__PURE__ */ jsx(Stack, { className, children: header && /* @__PURE__ */ jsx(Typography, { variant: "body2", marginBottom: 1, children: header }) });
        case "range-date":
          return /* @__PURE__ */ jsxs(Stack, { className, children: [
            header && /* @__PURE__ */ jsx(Typography, { variant: "body2", marginBottom: 1, children: header }),
            /* @__PURE__ */ jsx(
              DateRangePickerStyled,
              {
                placeholder: "__.__.____-__.__.____",
                character: "-",
                weekStart: 1,
                showHeader: false,
                format: "dd.MM.yyyy",
                caretAs: () => /* @__PURE__ */ jsx(Icon, { size: "l", icon: /* @__PURE__ */ jsx(CalendarIcon, {}) }),
                ...props
              }
            )
          ] });
        case "range-time":
          return /* @__PURE__ */ jsxs(Stack, { className, children: [
            header && /* @__PURE__ */ jsx(Typography, { variant: "body2", marginBottom: 1, children: header }),
            /* @__PURE__ */ jsx(
              TimeRangePickerStyled,
              {
                character: "-",
                placeholder: "___:___-___:___",
                caretAs: () => /* @__PURE__ */ jsx(Fragment, {}),
                ...props
              }
            )
          ] });
        default:
          notReachable(type);
      }
    },
    [type, isTextField, locale, header, props]
  );
  return /* @__PURE__ */ jsx(CustomProvider, { locale: locale === "ru" ? ruRU : enGB, theme: theme.palette.mode, children: renderDatePicker });
};
DatePickerV2.displayName = "DatePicker";
var DatePickerV2_default = DatePickerV2;
export {
  DatePickerV2_default as default
};
